import { render, staticRenderFns } from "./verifyForm.vue?vue&type=template&id=1b37e6a6"
import script from "./verifyForm.vue?vue&type=script&lang=js"
export * from "./verifyForm.vue?vue&type=script&lang=js"
import style0 from "./verifyForm.vue?vue&type=style&index=0&id=1b37e6a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports